import { react, useState } from 'react';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import ProbabilityGauge from './ProbabilityGauge';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import StyledRadio from '../StyledExtensions/StyledRadio'

export default function AvailableDateAndCustomerType(props) {

    const [highRiskAcknowledged, sethighRiskAcknowledged] = useState(props.pickupRequest.CustomerDateAvailableForPickup === undefined ? false : true); // already selected a date, so we know they acknowledged
    const [availableDate, setAvailableDate] = useState(props.pickupRequest.CustomerDateAvailableForPickup === undefined ? dayjs() : props.pickupRequest.CustomerDateAvailableForPickup);
    const [customerType, setCustomerType] = useState(props.pickupRequest.CustomerType === undefined ? 'Residence' : props.pickupRequest.CustomerType);

    function calculatePickupGaugePercent() {
        let probabilityScore = 0;
        let recyclerCount = 0;

        if (props.pickupData !== undefined && props.pickupData !== null) {

            if (typeof props.pickupData.ActiveReturnerCategories === 'string') {
                props.pickupData.ActiveReturnerCategories = JSON.parse(props.pickupData.ActiveReturnerCategories);
            }
            if (props.pickupData.ActiveReturnerCategories.length > 0) {
                for (let i = 0; i < props.pickupData.ActiveReturnerCategories.length; i++) {
                    probabilityScore += props.pickupData.ActiveReturnerCategories[i].Count * props.pickupData.ActiveReturnerCategories[i].Weight;
                    recyclerCount += props.pickupData.ActiveReturnerCategories[i].Count;
                }
            }

            if (probabilityScore > 100) {
                probabilityScore = 100; // normalize to 100%
            }
        }
        return {
            probabilityScore: probabilityScore / 100.0,
            recyclerCount: recyclerCount
        }
    }

    let recyclerInfo = calculatePickupGaugePercent();
    let isHighRisk = false;
    if (recyclerInfo.probabilityScore * 100 < parseInt(props.pickupData.HighRiskProbabilityPercent)) {
        isHighRisk = true;
    }
   
    function buildHighRiskAcknowledgement() {
        return (
            <div style={{display:'flex', justifyContent:'center'} }>
                <div style={{maxWidth:'400px'} }>
                    <div style={{marginTop:'5px'} }>
                        Unfortunately, this means it may take multiple days for your pickup to be scheduled and in a worst case it may not be scheduled.
                    </div>
                    <div style={{ marginTop: '5px' }}>
                        However, after you submit a request, you will be notified immediately when it is schedule and provided the date/time of the pickup. You can also cancel your request at any time.
                    </div>
                    <div style={{ marginTop: '5px' }}>
                        We apologize for the inconvenience and are working hard to provide more reliable service in your area soon!
                    </div>
                    <div style={{ marginTop: '5px', display:'flex', justifyContent:'space-between' }}>
                        <Button variant="contained" color="sipzeeYellow" onClick={props.onCancel} style={{marginRight:'2px'} }>Try Later</Button>
                        <Button variant="contained" color="sipzeeGreen" onClick={() => sethighRiskAcknowledged(true)} style={{ marginLeft: '2px' }}>Continue with Pickup</Button>
                    </div>
                </div>
            </div>
        )
    }

    function isValidated() {
        return true; // nothing to validate on this form
    }

    function buildDateAndCustomerTypeSelection() {
        return (<div>
            <div className={styles.cardQuestion }>
                When will your cans/bottles be available for pickup?
            </div>
            <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        value={availableDate}
                        minDate={dayjs()}
                        maxDate={dayjs().add(7, 'day')}
                        onChange={(newValue) => {
                            setAvailableDate(newValue);
                        }}
                        views={['day']}
                        renderInput={(params) => <TextField {...params} />}
                    />
                </LocalizationProvider>
            </div>
            <div style={{marginTop:'-20px'} }>
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                    >
                        <FormControlLabel value="Residence" control={<StyledRadio checked={customerType === 'Residence'} onChange={(e) => setCustomerType(e.target.value)} />} label={<span><HomeIcon style={{position:'relative',top:'5px'} } /> Residence</span>} />
                        <FormControlLabel value="Business" control={<StyledRadio checked={customerType === 'Business'} onChange={(e) => setCustomerType(e.target.value)} />} label={<span>Business <BusinessIcon style={{ position: 'relative', top: '5px' }} /></span>} />
                        
                    </RadioGroup>
                </FormControl>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' ,marginTop:'10px'}} >
                <div style={{ display: 'flex', width:'300px', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                    <Button variant={isValidated() ? "contained" : "outlined" } color="sipzeeGreen" disabled={!isValidated()} onClick={() => props.onNext(availableDate, customerType)}>Next <KeyboardArrowRight /></Button>
                </div>
            </div>
        </div>
        );
    }

    return (
        <div>
            {isHighRisk && !highRiskAcknowledged ? 
                <div style={{marginTop:'2px'} }>We currently only have <b>{recyclerInfo.recyclerCount}</b> recycler {(recyclerInfo.recyclerCount > 1 ? 's' : '')} in <b>{props.pickupData.ZipCodeInfo.City}</b></div>
                :
                <div style={{ marginTop: '2px' }}>We currently have <b>{recyclerInfo.recyclerCount}</b> recycler {(recyclerInfo.recyclerCount > 1 ? 's' : '')} in <b>{props.pickupData.ZipCodeInfo.City}</b></div>
            }

            <ProbabilityGauge text={recyclerInfo.recyclerCount + ' recycler' + (recyclerInfo.recyclerCount > 1 ? 's' : '')} percent={recyclerInfo.probabilityScore} />

            {isHighRisk && !highRiskAcknowledged ? 
                buildHighRiskAcknowledgement()
                :
                buildDateAndCustomerTypeSelection()
            }

        </div>
    )

   

}
